import { Injectable } from '@angular/core';
import { jsPDF} from 'jspdf';
import autoTable from 'jspdf-autotable'

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() { }

  generateFile(headers:Array<any>,data:Array<any>,title:string,filename:string): void {

    let year = new Date().getFullYear();
    const doc = new jsPDF();
    
    doc.setFontSize(12);
    doc.text(year+' Versus finances',4,5);
    
    doc.setFontSize(14);
    doc.text(title, 90, 10);
    
    doc.setFontSize(12);
     
    autoTable(doc,{
      head: headers,
      body: data,
      startY: 15,
      headStyles :{
        textColor:[255,255,255],
        fillColor:[44,94,68]  
      }
    });
    
    
    doc.save(filename+'.pdf');
  }

  
}
